<template>
    <nav class="breadcrumb has-arrow-separator" aria-label="breadcrumbs">
        <ul>
            <li >
                <a class="tag is-light is-rounded" :href="product.categoryObj.getProdListUrl">
                    <p class="m-l-5">{{product.categoryObj.title}}</p>
                </a>
            </li>
            <li >
                <a class="tag is-light is-rounded" :href="product.subcategoryObj.getProdListUrl">
                    <p>{{product.subcategoryObj.title}}</p>
                </a>
            </li>
            <li class="is-active"><a class="tag is-light is-rounded" href="#" aria-current="page"><p>{{product.title}}</p></a></li>
        </ul>
    </nav>
</template>

<script>
export default {
    props:{
        product:{
            type: Object,
            default: new Object({}),
        }
    },

}
</script>